export default "__VITE_ASSET__BfNMNUS1__"